<template>
	<div class="activity_center">
		<div class="banner">
			<h1>活动中心</h1>
			<h5>A C T I V I T Y &nbsp;&nbsp; C E N T E R</h5>
			<div class="list_title">
				<div class="yellow_cir"></div>
				<h2>活动列表</h2>
			</div>
		</div>
		<div class="activity_list">
			<div class="activity_item" v-for="item in activityList">
				<a  target="_blank" :href=" item.partakeNumber>0? '/huodong/libao.html' : item.activityUrl">
					<img :src="item.banner" alt='版权登记'/>
					<h3>{{item.name}}</h3>
					<p>{{item.content}}</p>
					<span>{{item.beginDate}} ~ {{item.endDate}}</span>
					<i>了解详情 </i>
				</a>	
			</div>
		</div>
	</div>
</template>

<script>
    import {_getActivityAll} from '@/api/activity.js'

    export default {
        data() {
            return {
            	activityList:[]
            }
        },
        created(){
        	let params = {
        		'sort':'createDate',
        		'order':'desc',
        		'type':'5',
				'status':'1'
        	}
        	_getActivityAll(params).then(res=>{
        		this.activityList = res.result.records
        		console.log(res)
        	})
        },
       	methods:{
       		
       	}
    };
</script>

<style lang="less" scoped>
	.banner{
		width: 100%;
		height: 300px;
		text-align: center;
		padding-top: 30px;
		color: #040404;
		background-image: url(../../assets/images/activity_banner.png);
		background-size:100%;
		background-repeat: no-repeat; 
		margin-bottom: 30px;
		cursor: default;
	}
	.banner h1{
		font-size: 28px;
		line-height: 80px;
	}
	.list_title{
		font-size: 16px;
		line-height: 140px;
		text-align: center;
		position: relative;
		top: 54px;
	}
	.yellow_cir{
		width: 50px;
		height: 50px;
		border-radius: 50%;
		background-color: #FFD800;
		position: absolute;
		left: calc(50% - 25px);
		top: 45px;
	}
	.list_title h2{
		position: relative;
	}
	.activity_list{
		width: 1060px;
		margin: 0 auto;
	}
	.activity_item{
		min-height: 400px;
		width: 960px;
		margin: 0 auto;
		padding: 30px;
		margin-bottom: 30px;
		/*box-shadow: 0 0 1px 0 #666;*/
		box-shadow: 0px 2px 40px 0px rgba(0,0,0,0.04);
		border-radius: 1px 2px 6px 16px;
		cursor: default;
		img{
			width: 900px;
			height: 200px;
			border: 1px solid #FFD800;
			margin-bottom: 20px;
		}
		h3{
			font-size: 20px;
			line-height: 24px;
			color:#040404;
		}
		p{
			font-size: 16px;		
			color: #666;
			line-height: 30px;
			margin-bottom: 30px;
		}
		span,i{
			font-style: normal;
			font-size: 14px;
			color: #666;
		}
		span{
			float: left;
			padding-left: 24px;
			background-image: url(../../assets/activity_clock.png);
			background-repeat: no-repeat;
			background-size: 14px;
			background-position: 0px 3px;
		}
		i{
			float: right;
			padding-right: 60px;
			cursor: pointer;
			background-image: url(../../assets/arrow-p.png);
			background-repeat: no-repeat;
			background-position: 64px 4px;
		}
	}
	
</style>